import { Box } from '@mui/material'
import React from 'react'
import loaderData from './Loader.json'
import Lottie from 'lottie-react'

const Loader = () => {
  return (
    <>
    <Box sx={{display:'flex', alignItems:'center', justifyContent:'center', height: 'calc(100vh - 84px)'}} >
        <Lottie animationData={loaderData} loop={true} style={{height: '200px', width: 'auto'}} />
    </Box>
    </>
    
  )
}

export default Loader